import React from 'react';
import { extractStyle, createCache } from '@ant-design/cssinjs';

export const antdCache = createCache();

export const onPreRenderHTML = ({ getHeadComponents, replaceHeadComponents }) => {
  const headComponents = getHeadComponents();
  const styles = extractStyle(antdCache);
  antdCache.cache.clear();
  headComponents.splice(0, 0, <style dangerouslySetInnerHTML={{ __html: styles }} />);
  replaceHeadComponents(headComponents);
};

export { default as wrapRootElement } from './src/root-wrapper';
